"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var common_kit_exports = {};
__export(common_kit_exports, {
  CodeSnippetsKit: () => CodeSnippetsKit,
  CommonKit: () => CommonKit,
  CommonKitFactory: () => CommonKitFactory,
  CommonListKitFactory: () => CommonListKitFactory,
  ListKit: () => ListKit,
  TableKit: () => TableKit,
  TextColorStylingKit: () => TextColorStylingKit
});
module.exports = __toCommonJS(common_kit_exports);
var import_tiptapExtensions = require("../tiptapExtensions");
var import_kit = require("../kit");
var import_colors = require("../marks/colors");
var import_inlineComment = require("../marks/inlineComment");
var import_nodes = require("../nodes");
var import_code = require("../marks/code");
var import_bpmn = require("../nodes/bpmn");
var import_mermaid = require("../nodes/mermaid");
var import_openapi = require("../nodes/openapi");
const CommonKitFactory = /* @__PURE__ */ __name((e) => ({
  text: e(import_tiptapExtensions.Text),
  document: e(import_tiptapExtensions.Document),
  paragraph: e(import_tiptapExtensions.Paragraph),
  bold: e(import_tiptapExtensions.Bold),
  italic: e(import_tiptapExtensions.Italic),
  strike: e(import_tiptapExtensions.Strike),
  // multicolor keeps the optional `color` attribute of the highlight mark,
  // marks without the attribute are still rendered with the default highlight color
  highlight: e(import_tiptapExtensions.Highlight, { multicolor: true }),
  comment: e(import_nodes.CommentNode),
  markdown: e(import_nodes.MarkdownNode, { HTMLAttributes: { class: "proseCodeBlock" } }),
  inlineComment: e(import_inlineComment.InlineCommentMark),
  horizontalRule: e(import_tiptapExtensions.HorizontalRule),
  heading: e(import_tiptapExtensions.Heading),
  underline: e(import_tiptapExtensions.Underline),
  blockquote: e(import_tiptapExtensions.Blockquote, { HTMLAttributes: { class: "proseBlockQuote" } }),
  link: e(import_tiptapExtensions.Link.extend({ inclusive: false }), {
    openOnClick: false,
    HTMLAttributes: { class: "cursor-pointer", rel: "noopener noreferrer", target: "_blank" }
  }),
  textAlign: e(import_tiptapExtensions.TextAlign, {
    types: ["heading", "paragraph"],
    alignments: ["left", "center", "right"],
    defaultAlignment: null
  }),
  typography: e(import_tiptapExtensions.Typography),
  dropcursor: e(import_tiptapExtensions.Dropcursor),
  gapcursor: e(import_tiptapExtensions.Gapcursor),
  history: e(import_tiptapExtensions.History)
}), "CommonKitFactory");
const CommonKit = (0, import_kit.extensionKit)("common-kit", CommonKitFactory);
const TextColorStylingKit = (0, import_kit.extensionKit)(
  "text-color-styling",
  (e) => ({
    textStyle: e(import_tiptapExtensions.TextStyle),
    testColor: e(import_colors.TextColor),
    backgroundColor: e(import_colors.BackgroundColor, { types: ["tableCell"] })
  })
);
const TableKit = (0, import_kit.extensionKit)(
  "table-kit",
  (e) => ({
    table: e(import_tiptapExtensions.Table, { resizable: false, HTMLAttributes: { class: "proseTable" } }),
    tableRow: e(import_tiptapExtensions.TableRow),
    tableHeader: e(import_tiptapExtensions.TableHeader),
    tableCell: e(import_tiptapExtensions.TableCell)
  })
);
const CodeSnippetsKit = (0, import_kit.extensionKit)(
  "code-snippet-kit",
  (e) => ({
    codeBlock: e(import_nodes.CodeBlockExtension, import_nodes.codeBlockOptions),
    codeBlockMermaid: e(import_mermaid.MermaidExtension, import_mermaid.mermaidOptions),
    codeBlockBpmn: e(import_bpmn.BpmnExtension, import_bpmn.bpmnOptions),
    codeBlockOpenApi: e(import_openapi.OpenApiExtension, import_openapi.openApiOptions),
    codeInline: e(import_code.CodeExtension, import_code.codeOptions)
  })
);
const CommonListKitFactory = /* @__PURE__ */ __name((e) => ({
  listItem: e(import_tiptapExtensions.ListItem.extend({ group: "listItems" })),
  bulletList: e(import_tiptapExtensions.BulletList.extend({ content: "listItems+" })),
  orderedList: e(import_tiptapExtensions.OrderedList.extend({ content: "listItems+" }))
}), "CommonListKitFactory");
const ListKit = (0, import_kit.extensionKit)(
  "list-kit",
  (e) => ({
    ...CommonListKitFactory(e),
    todoItem: e(import_nodes.TodoItemNode),
    todoList: e(import_nodes.TodoListNode)
  })
);
//# sourceMappingURL=common-kit.js.map
